<template>
  <VModal
      :title="category.name ? 'ویرایش دسته بندی ' + category.name : 'ایجاد دسته بندی'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="type" :value="$route.params.type">
      <input type="hidden" name="_method" value="PUT" v-if="category.name">

      <div class="mt-5">
        <VImageInput :photo="category.photo ? category.photo.path : ''"/>
      </div>

      <fieldset class="border rounded p-4 mt-4 pt-0">
        <legend>نام دسته بندی</legend>

        <div v-for="lang in languages" :key="lang.id" class="mt-4">
          <label>نام {{ lang.name }}</label>
          <VInput
              type="text"
              :name="'name_' + lang.code"
              :value="$helper.getTextValue(lang, category.name_text)"
              placeholder="نام"
              class="mt-4"
              :required="lang.code === 'fa'"/>
        </div>
      </fieldset>

      <div class="mt-4">
        <label>ترتیب</label>
        <VInput type="number" name="order" :value="category.order" placeholder="ترتیب نمایش دسته بندی" class="mt-4"
                required/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <div>
          <label>وضعیت دسته بندی</label>
          <h6 class="mt-1 text-sm text-muted">در صورت غیرفعال بودن دسته بندی، دسته بندی نمایش داده نمیشود</h6>
        </div>

        <VSwitch v-model="active" :value="category.active"/>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VSwitch from "@/components/General/VSwitch";
import VButton from "@/components/General/VButton";
import VImageInput from "@/components/General/VImageInput";
import {createCategory, updateCategory} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import {mapState} from "vuex";

export default {
  name: "ModalCategory",
  components: {VLoadingScreen, VAlert, VImageInput, VButton, VSwitch, VInput, VModal},
  emits: ['created'],
  props: {
    show: Boolean,
    category: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      image: '',
      active: 1,
      loading: false,
      errors: [],
    }
  },
  computed: {
    ...mapState(['languages'])
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let category = new FormData(this.$refs.form)
      category.append('active', this.active)

      if (this.category.name) {
        this.updateCategory(category)
      } else {
        this.createCategory(category)
      }
    },
    updateCategory(category) {
      updateCategory(this.category.id, category)
          .then(resp => {
            this.$emit('edited', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    },
    createCategory(category) {
      createCategory(category)
          .then(resp => {
            this.$emit('created', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    },
  }

}
</script>

<style scoped>

</style>